<template>
  <div class="ticket">
    <ul class="info-1">
      <li>{{ticket.title}}</li>
      <li><b-badge variant="secondary">{{ticket.updatedAt}}</b-badge></li>
    </ul>
    <ul class="info-2">
      <li><b-icon icon="chat-right-text-fill"></b-icon> {{ticket.comments}}</li>
      <li v-if="ticket.active == true"><b-badge variant="success">Aktif</b-badge></li>
      <li v-else><b-badge variant="warning">Pasif</b-badge></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'TicketCard',
  props: {
    ticket: Object
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/pages/Support/Ticket/components/TicketCard.vue